import React from "react";
import { Link } from "gatsby";

import "./realization-tile.scss";

const RealizationTile = ({ year, image, title, location, link, logo }) => {
   return (
      <Link to={link}>
         <div className="realization-tile">
            <div className="realization-tile__img-wrapper">
               <img src={image} alt={title} className="realization-tile__img" />
            </div>
            <img src={logo} alt={title} className="realization-tile__logo" />
            <div className="realization-tile__wrapper">
               <h5 className="realization-tile__title">{title}</h5>
               <div className="realization-tile__info">
                  {year} - {location}
               </div>
            </div>
         </div>
      </Link>
   );
};

export default RealizationTile;
